import {EntityModel} from "@fedeltapointofsale/data-client";
import {TerminalData} from "./terminal.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class TerminalEntityModel extends EntityModel<TerminalData> {

    constructor(injector: Injector) {
        super(injector, TerminalData);
    }
}
